import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import { RootLayout } from "../../layout";
import { React, useState, useEffect } from "react";

import PatientsList from "../../components/patients/PatientsList";
import api from "../../services/api";
import ButtonGoBack from "../../components/Buttons/outlinedGoback";
import Loading from "../../components/Loading";

export default function Pacientes() {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    try {
      setIsLoading(true);
      const { data } = await api.post("/pacientes/");
      setData(data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    } finally {
      setIsLoading(false);
    }
  }

  const styles = {
    title: {
      fontWeight: "600",
      fontSize: "26px",
      lineHeight: "35px",
      color: "#063F5E",
      fontFamily: "Nunito, sans-serif ",
    },
    subtitle: {
      fontWeight: "300",
      fontSize: "18px",
      lineHeight: "25px",
      marginBottom: "5px",
      marginTop: "10px",
      color: "#1E729F",
    },
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <RootLayout>
        {isLoading ? (
          <Loading />
        ) : (
          <Box>
            <Box paddingBottom={"20px"}>
              <ButtonGoBack />
              <Box sx={{ mb: "16px" }}>
                <Box style={styles.title}>Pacientes</Box>
              </Box>
              <PatientsList isModal={false} dados={data} />
            </Box>
          </Box>
        )}
      </RootLayout>
    </Box>
  );
}
